// @flow
export default {
  set(key: string, value: any): string {
    window.localStorage[key] = value;
    return window.localStorage[key];
  },
  get(key: string, defaultValue?: any = null): string | null {
    return window.localStorage[key] || defaultValue;
  },
  setObject(key: string, value: string): string {
    window.localStorage[key] = JSON.stringify(value);
    return this.getObject(key);
  },
  getObject(key: string): {} {
    return JSON.parse(window.localStorage[key] || null);
  },
  remove(key: string): void {
    window.localStorage.removeItem(key);
  },
  clear(): void {
    window.localStorage.clear();
  }
};
